class Tags {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/calendar-activity-tags`;
    this.apiClient = apiClient;

  }

  async getAllTags() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

}

export default Tags;